import React, { useState } from 'react';
import logo from '../assets/images/logo.webp';
import axios from 'axios';
import { FaFacebook, FaInstagram, FaYoutube } from 'react-icons/fa';

const Footer = ({ language = 'en' }) => {
  const [testimonial, setTestimonial] = useState({ name: '', message: '' });

  const handleChange = (e) => {
    setTestimonial({ ...testimonial, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('http://localhost:5000/api/testimonials', {
        name: testimonial.name,
        message: testimonial.message,
      });

      alert(
        language === 'am'
          ? '✅ አመሰግናለሁ! አስተያየትዎ ተልኳል።'
          : '✅ Thank you! Your testimonial has been sent for review.'
      );
      setTestimonial({ name: '', message: '' });
    } catch (err) {
      alert(language === 'am' ? 'ልከቱ አልተሳካም።' : 'Submission failed. Please try again.');
    }
  };

  return (
    <footer className="bg-dark text-white pt-5 pb-4">
      <div className="container text-md-left">
        <div className="row text-md-left">
          {/* Logo + Description */}
          <div className="col-md-4 col-lg-3 col-xl-3 mx-auto mt-3">
            <img src={logo} alt="Club Logo" height="50" className="mb-3 rounded-circle" />
            <p>
              {language === 'am'
                ? 'የኢትዮጵያ የመከላከያ ኃይል ኦፊሰር ክለብ ከጤና፣ እና እንክብካቤ እስከ ዓለም የሚቀን የክለብ አገልግሎቶች ድረስ የተለያዩ የላቀ አገልግሎቶችን ያቀርባል።'
                : 'Ethiopian Defense Force Officers Club offers a wide range of premium services, from wellness and fitness to world-class event hosting.'}
            </p>
          </div>

          {/* Our Services */}
          <div className="col-md-2 col-lg-2 col-xl-2 mx-auto mt-3">
            <h5 className="text-uppercase mb-4 fw-bold">
              {language === 'am' ? 'አገልግሎቶቻችን' : 'Our Services'}
            </h5>
            <p><a href="/spa" className="text-white text-decoration-none">{language === 'am' ? 'ስፓ እና ማሳሰቢያ' : 'Spa & Massage'}</a></p>
            <p><a href="/gym" className="text-white text-decoration-none">{language === 'am' ? 'ጂምናዚየም' : 'Gymnasium'}</a></p>
            <p><a href="/tennis" className="text-white text-decoration-none">{language === 'am' ? 'ቴኒስ መሳሪያ ቦታ' : 'Ground Tennis'}</a></p>
            <p><a href="/hall" className="text-white text-decoration-none">{language === 'am' ? 'የክለብ አዳራሽ' : 'Event Hall'}</a></p>
          </div>

          {/* Useful Links */}
          <div className="col-md-2 col-lg-2 col-xl-2 mx-auto mt-3">
            <h5 className="text-uppercase mb-4 fw-bold">
              {language === 'am' ? 'ተጠቃሚ ሊንኮች' : 'Useful Links'}
            </h5>
            <p><a href="/" className="text-white text-decoration-none">{language === 'am' ? 'መነሻ ገጽ' : 'Home'}</a></p>
            <p><a href="/about" className="text-white text-decoration-none">{language === 'am' ? 'ስለእኛ' : 'About'}</a></p>
            <p><a href="/services" className="text-white text-decoration-none">{language === 'am' ? 'አገልግሎቶች' : 'Services'}</a></p>
            <p><a href="/contact" className="text-white text-decoration-none">{language === 'am' ? 'ያግኙን' : 'Contact Us'}</a></p>
          </div>

          {/* Testimonial Form */}
          <div className="col-md-4 col-lg-3 col-xl-3 mx-auto mt-3">
            <h5 className="text-uppercase mb-3 fw-bold">
              {language === 'am' ? 'እርስዎን ያጋሩ' : 'Share Your Experience'}
            </h5>
            <form onSubmit={handleSubmit}>
              <div className="mb-2">
                <input
                  type="text"
                  name="name"
                  className="form-control form-control-sm"
                  placeholder={language === 'am' ? 'ስምዎ' : 'Your Name'}
                  required
                  value={testimonial.name}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-2">
                <textarea
                  name="message"
                  className="form-control form-control-sm"
                  rows="2"
                  placeholder={language === 'am' ? 'ልምድዎን ያካፍሉ...' : 'Share your experience...'}
                  required
                  value={testimonial.message}
                  onChange={handleChange}
                ></textarea>
              </div>
              <button type="submit" className="btn btn-outline-light btn-sm">
                {language === 'am' ? 'ላክ' : 'Submit'}
              </button>
            </form>

            <h6 className="mt-4 fw-bold">
      {language === 'en' ? 'Call Us' : 'ይደውሉልን'}
    </h6>
                <p className="mb-1">
  <a href="tel:+251926555599" className="text-white text-decoration-none">+251 92 655 5599</a>
</p>
<p className="mb-1">
  <a href="tel:+251113717317" className="text-white text-decoration-none">+251 11 371 7317</a>
</p>
<p className="mb-3">
  <a href="tel:+251113717318" className="text-white text-decoration-none">+251 11 371 7318</a>
</p>
          </div>
        </div>

        {/* Follow Us */}
        <div className="row mt-4">
          <div className="col text-center">
            <div className="d-flex justify-content-center gap-4">
              <a href="#" className="text-white fs-4"><FaFacebook /></a>
              <a href="#" className="text-white fs-4"><FaInstagram /></a>
              <a href="#" className="text-white fs-4"><FaYoutube /></a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <hr className="my-4" />
        <div className="row text-center">
          <div className="col">
            <p className="mb-0">
              &copy; {new Date().getFullYear()} {language === 'am'
                ? 'የኢትዮጵያ መከላከያ ኃይል ኦፊሰር ክለብ። መብት የተጠበቀ ነው።'
                : 'Ethiopian Defense Force Officers Club. All rights reserved.'}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
